import { render, staticRenderFns } from "./recycleH5.vue?vue&type=template&id=5a266299&scoped=true&"
import script from "./recycleH5.vue?vue&type=script&lang=js&"
export * from "./recycleH5.vue?vue&type=script&lang=js&"
import style0 from "./recycleH5.vue?vue&type=style&index=0&id=5a266299&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a266299",
  null
  
)

export default component.exports